<template>
	<div class="calendar_con pt-22 plr-16 box-s">
    <div class="list_every h471 pr pt-45 box-s">

      <img class="calen_img" src="../../assets/img/bg/calendar_bg.png" alt="">
      <div class="flexs pr text-center fz-14 c1 mb-30">
        <div class="flex1">
          <div class="mb-17">学习天数</div>
          <div class="data_num_sty">{{data.statistic && data.statistic.study_day_total?data.statistic.study_day_total:0 }}</div>
        </div>

        <div class="word_line ps-50"></div>

        <div class="flex1">
          <div class="mb-17">学习单词</div>
          <div class="data_num_sty">{{data.statistic && data.statistic.study_word_total?data.statistic.study_word_total: 0}}</div>
        </div>
      </div>


      <div>
        <Calendar
         :textTop="['日','一','二','三','四','五','六']"
          @choseDay="clickDay"
          @changeMonth="changeDate"
          :sundayStart="true"
          :markDate="classarr"
        ></Calendar>
      
      </div>
    </div>

    <div class="btn_contain">
      <div class="blue_btn bg_sky" @click="shareBtn">
        分享得积分
      </div>
    </div>
    <load :loadFlag="loadFlag"></load>
    <shareBg v-if="showShare" @hideShare="shareBtn"></shareBg>
    <shareOk v-if="showShareOk" @hideShare="shareBtnOk" :integral="integral"></shareOk>
	</div>
</template>
<script>
	import load from "@/components/loading"
	import { getEnglishStudyCalendar, userShare } from '@/api/api.js'
	import { getShare } from '@/utils/common.js'
  import Calendar from 'cander';
  import shareBg from '@/components/shareBg.vue';
  import shareOk from '@/components/shareOk.vue';
	import wx from "weixin-js-sdk";
	export default {
		components: {
      Calendar,
      shareBg,
      shareOk,
      load
		},
		data() {
			return {
        classarr: [],
        showShare: false,
        showShareOk: false,
        data: {},
        loadFlag: false,
        integral: 1
			};
		},
		created() {
   
		  this.initData(new Date())
		},
    mounted(){
      
      getShare().then(async()=>{
        const res = await userShare({ type: '1' })
         if(res.code == 1000){
           this.showShare = false
           console.log(this.showShare,'this.showShare')
           this.showShareOk = true
           this.integral = res.data.integral
         } else {
           this.$toast(res.msg)
         }
      }).catch(res=>{
        console.log(res)
      })
    },
		methods: {
      async initData(day){
        this.loadFlag = true
        
        const res = await getEnglishStudyCalendar({ date: [day.getFullYear(), day.getMonth() + 1].map(item => item < 10? '0' + item: item).join('-') })
        this.loadFlag = false
        if(res.code == 1000){
          this.data = res.data
          this.data.date.forEach(item => {
            if(item.status){
              const arr = item.day.split('-').map(i=> {
                if(i.split('')[0] == 0){
                  i = i.split('')[1]
                }
                return i
              } ).join('/')

              this.classarr.push({date:arr,className:"selected_sty"})
              
            }
          });
        }else {
					 this.$toast(res.msg)
				}
      },
      clickDay(data) {
        // console.log(data); //选中某天
      },
      changeDate(data) {
        console.log(data); //左右点击切换月份
        this.initData(new Date(data))
      },
      clickToday(data) {
        console.log(data); //跳到了本月
      },
      
      // 分享的积分
      async shareBtn(){
        this.showShare = !this.showShare
        
      },
      // 恭喜的积分
      shareBtnOk(){
        this.showShareOk = !this.showShareOk
      }
    }
	};
</script>
<style lang="less" scoped>
.h471 {
  height: 471px;
  overflow: auto;
}

/deep/.wh_content_all {
  background-color: #fff !important;
}

/deep/.wh_content_item {
  position: relative;
  height: 45px;
}

/deep/.wh_isMark {
  color: #D9D8D8 !important;
  background: #fff !important;
}

/deep/.wh_other_dayhide {
  color: #D9D8D8 !important;
}

/deep/.wh_item_date {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #333333;
  font-size: 12px !important;
}
/deep/.wh_content_li {
  color: #333333 !important;
  font-size: 14px !important;
}

/deep/.wh_jiantou2 {
  border-top: 2px solid #666666 !important;
  border-right: 2px solid #666666 !important;
  width: 4px  !important;
  height: 4px !important;
  border-color: #666666 !important;
}

/deep/.wh_jiantou1 {
  border-top: 2px solid #666666 !important;
  border-left: 2px solid #666666 !important;
  width: 4px !important;
  height: 4px !important;
 border-color: #666666 !important;
}

/deep/.wh_jiantou1:active
 {
  border-color: #666666 !important;
}
/deep/.wh_jiantou2:active{
  border-color: #666666 !important;
}
/deep/.wh_content_item .wh_chose_day {
  width: 27px;
  height: 27px;
  background: #fff !important;
}


/deep/.wh_content_item .wh_isToday {
  width: 27px;
  height: 27px;
  background: #497CFF !important;
  box-shadow: 0px 6px 6px 0px rgba(73, 124, 255, 0.12);
  border-radius: 50%;
  color: #fff !important;
  border: 1px solid #497CFF;
}

/deep/.wh_top_tag {
  font-size: 10px;
  font-weight: 500;
  color: #666666;
  line-height: 10px;
}

/deep/.wh_isMark {
  color: #333333 !important;
}

/deep/.wh_isMark::after {
  content: '';
  width: 4px;
  height: 4px;
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #497CFF !important;
  border-radius: 50%;
}

.calen_img {
  position: absolute;
  top: 20px;
  left: 18px;
  width: 130px;
  height: 38px;
}

/deep/.wh_content_li {
  width: 80px;
}

/deep/.wh_top_changge li:first-child {
  justify-content: flex-end;
}

/deep/.wh_top_changge li:last-child {
  justify-content: flex-start;
}


</style>
